import {Component} from 'react';
import h from 'react-hyperscript';
import {h3, p} from 'Components/Typography/Typography';
import CardWithSidebar from 'Components/Cards/CardWithSidebar';
import Button from 'Components/Buttons/Buttons';
import SurveyHeader from 'Pages/TransformationSurvey/SurveyHeader/SurveyHeader';
import SurveyElementHeader from
  'Pages/TransformationSurvey/SurveyElementHeader/SurveyElementHeader';
import RadioGroupVertical from 'Components/Form/RadiosVertical';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
class Review extends Component {
  constructor(props) {
    super(props);
    this.reviewBars = null;
    const fieldValues = props.fieldValues['reviewValues'];

    const elementComplete = fieldValues &&
    fieldValues.elementComplete ?
    {...fieldValues.elementComplete} :
    {
      total: 1,
      answered: 0,
      percentage: 0,
    };
    const surveyValues = fieldValues &&
    fieldValues.surveyValues ?
    {...fieldValues.surveyValues}: {
      priority: {value: null},
      comments: null,
    };
    this.state = {
      elementComplete: elementComplete,
      surveyValues: surveyValues,
    };
    this.handleRadios = this.handleRadios.bind(this);
    this.handleTextarea = this.handleTextarea.bind(this);
  }

  handleRadios(e) {
    const selectedName = e.target.getAttribute('name');
    const selectedVal = e.target.value;
    const isChecked = e.target.checked;
    let priority;
    if (isChecked && selectedName) {
      priority = {
        name: selectedName,
        value: selectedVal,
        type: 'PRIORITY',
      };
    };
    this.setRadioValue(priority);
  }

  setRadioValue(value) {
    this.setState((state, props) => ({
      surveyValues: {
        ...this.state.surveyValues,
        priority: value,
      },
    }), () => {
      this.checkElementProgress();
    });
  }

  componentDidUpdate(prevProps) {

  }

  checkElementProgress() {
    const currentElementProgress = this.checkPercentComplete();
    this.setState({
      elementComplete: currentElementProgress,
    }, () => {
      this.props.saveValues(this.state, 'reviewValues', true);
      this.checkLastStepProgress();
    });
  }

  checkLastStepProgress() {
    if (this.state.elementComplete.percentage !== 1) {
      return 'button--centered ';
    } else {
      return 'button--centered';
    }
  }

  checkPercentComplete() {
    const values = this.state.surveyValues;
    const numTotal = this.state.elementComplete.total;
    let numAnswered = 0;

    if (values.priority) {
      numAnswered ++;
    }

    if (values.comments) {
      numAnswered = numAnswered + 1;
    }

    const completeObj = {
      total: numTotal,
      answered: numAnswered,
      percentage: numAnswered / numTotal,
    };

    return completeObj;
  }

  handleTextarea(e) {
    this.setTextareaValue(e.target.value);
  }

  setTextareaValue(value) {
    this.setState((state, props) => ({
      surveyValues: {
        ...this.state.surveyValues,
        comments: value,
      },
    }));
  }

  render() {
    const color = 'text--red';
    const padding = 'padding-bottom--micro';
    const pClass = `${color} text--center ${padding} text-center footnote`;
    const sbtClr = 'text--grey';
    const sbtPadding = 'padding-top--micro';
    const submitClass = `${sbtClr} ${sbtPadding} text-center footnote`;

    return (
      h('div', {
        className: 'container survey-element__container',
      }, [
        h(SurveyHeader, {
          key: 'survey-element-header__key',
          districtName: this.props.districtName,
          totalPercentComplete: this.props.totalPercentComplete,
        }, null),

        h(CardWithSidebar, {
          key: 'review-card__key',
          className: this.props.className,
          goToStep: this.props.goToStep,
          totalPercentComplete: this.props.totalPercentComplete,
          showSectionProgress: this.props.showSectionProgress,
          completedSteps: this.props.completedSteps,
          activeStep: this.props.activeStep,
          sidebarItems: this.props.sidebarItems,
          fieldValues: this.props.fieldValues,
        }, [

          h(SurveyElementHeader, {
            answered: this.state.elementComplete.answered,
            total: this.state.elementComplete.total,
          }, null),

          h('div', {
            key: 'card-main__content__key',
            className: 'card-main__content',
          }, [
            h(h3, {
              key: 'review-title__key',
            }, this.props.content.title),

            h(RadioGroupVertical, {
              key: 'review-radios__key',
              id: this.props.content.priority.id,
              step: this.props.content.priority.step,
              name: this.props.content.priority.id,
              title: this.props.content.priority.title,
              onChange: this.handleRadios,
              value: this.state.surveyValues.priority.value,
              content: this.props.content.priority.options,
            }, null),
            h(p, {
              key: 'submit-error-message',
              className: pClass,
            }, this.props.submitErrorMessage),
            h('div', {
              key: 'review-card-submit-container__key',
              className: 'flex',
            }, [

              h(Button, {
                key: 'review-card-submit__key',
                to: '#',
                disabled: true,
                className: `${this.props.totalPercentComplete !== 1 ||
                  this.props.isLoadingSubmit ?
                  'button--disabled' :
                  ''} button--centered p-rel`,
                type: 'basic',
                onClick: (e) => {
                  e.preventDefault();
                  this.props.saveAndContinue(this.state, 'reviewValues', true);
                },
              }, [
                this.props.content.buttons.submit,
                h(LoadingIndicator, {classNames: `btn-overlay ${
                  this.props.isLoadingSubmit ? 'visible' : 'hidden'
                }`}, null),
              ]),
            ]),
            h(p, {
              key: 'submit-button-message',
              className: submitClass,
            }, this.props.content.buttons.submitMessage),
          ]),
        ]),
      ])
    );
  }
}


export default Review;
